import axiosInstance from '../helpers/axiosConfig';
import { createAsyncThunk } from "@reduxjs/toolkit";

export const register = createAsyncThunk(
    'auth/register',
    async ({ email, password, first_name, last_name, membership_type }, { rejectWithValue }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify ({ email, password, first_name, last_name, membership_type, is_admin: true, is_active: true });

        try {
            const res = await axiosInstance.post('users/register', body, config)
            return res.data
        } catch (err) {
            console.error('Registration error:', err.response.data);
            return rejectWithValue(err.response.data)
        }
    }
)